import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { style: {"padding":"8px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_SearchOutlined = _resolveComponent("SearchOutlined")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: _ctx.$t('screenTitle.paymentHistory')
  }, {
    default: _withCtx(() => [
      (_ctx.hasManagerPermission)
        ? (_openBlock(), _createBlock(_component_a_collapse, {
            key: 0,
            class: "mb-20"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_collapse_panel, { header: "Tìm bằng tên tài khoản" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form, {
                    ref: "formType",
                    model: _ctx.formModelByUName,
                    onFinish: _ctx.onFinishByUName,
                    scrollToFirstError: true,
                    layout: "vertical"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        label: _ctx.$t('labelText.user_name'),
                        name: "user_name"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.formModelByUName.user_name,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formModelByUName.user_name) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_a_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            "html-type": "submit",
                            loading: _ctx.isLoading
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('text.search')), 1)
                            ]),
                            _: 1
                          }, 8, ["loading"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model", "onFinish"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_a_table, {
        dataSource: _ctx.dataSource,
        columns: _ctx.columns,
        pagination: _ctx.pagination,
        onChange: _ctx.onChange,
        loading: _ctx.isLoading,
        scroll: {x: '100%'}
      }, {
        bodyCell: _withCtx(({ column, record, /*text*/ }) => [
          (column.key === 'action')
            ? (_openBlock(), _createBlock(_component_a_space, { key: 0 }, {
                default: _withCtx(() => [
                  (_ctx.hasManagerPermission && (record.status === _ctx.PaymentStatus.NOT_PAID))
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        title: "Huỷ giao dịch"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            danger: "",
                            size: "small",
                            onClick: ($event: any) => (_ctx.deletePaymentConfirm(record))
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_DeleteOutlined)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true)
        ]),
        customFilterDropdown: _withCtx(({ setSelectedKeys, selectedKeys, confirm, clearFilters, column }) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_a_input, {
              ref: "searchInput",
              placeholder: `Search ${column.dataIndex}`,
              value: selectedKeys,
              style: {"width":"188px","margin-bottom":"8px","display":"block"},
              onChange: (e) => setSelectedKeys(e.target.value),
              onPressEnter: ($event: any) => (_ctx.handleSearch(selectedKeys, confirm, column.dataIndex))
            }, null, 8, ["placeholder", "value", "onChange", "onPressEnter"]),
            _createVNode(_component_a_button, {
              type: "primary",
              size: "small",
              style: {"width":"90px","margin-right":"8px"},
              onClick: ($event: any) => (_ctx.handleSearch(selectedKeys, confirm, column.dataIndex))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_SearchOutlined)
              ]),
              default: _withCtx(() => [
                _createTextVNode("Search ")
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_a_button, {
              size: "small",
              style: {"width":"90px"},
              onClick: ($event: any) => (_ctx.handleReset(clearFilters))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Reset")
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["dataSource", "columns", "pagination", "onChange", "loading"])
    ]),
    _: 1
  }, 8, ["title"]))
}